/** Contactvelden die nodig zijn voor een Aan:-regel. */
export type EmailToFieldContact = {
  first_name: string;
  last_name: string;
  tussenvoegsel?: string | null;
  email?: string;
  email_prive?: string;
  email_werk?: string;
  dominicus_email?: string | null;
};

/** Contact + expliciet gekozen adres (bijv. na popup bij “Toevoegen”). */
export type EmailToFieldEntry = EmailToFieldContact & { sendEmail?: string };

function displayName(c: EmailToFieldContact): string {
  const t = c.tussenvoegsel?.trim();
  return [c.first_name, t, c.last_name].filter(Boolean).join(" ");
}

function preferredEmail(c: EmailToFieldContact): string | undefined {
  const dom = (c.dominicus_email ?? "").trim();
  if (dom.includes("@")) return dom;
  const primary = (c.email_prive || c.email || "").trim();
  if (primary.includes("@")) return primary;
  const sec = (c.email_werk ?? "").trim();
  if (sec.includes("@")) return sec;
  return undefined;
}

/**
 * Eén ontvanger voor het Aan-veld: `Naam <email@domein.nl>`.
 * Scheid meerdere adressen met {@link EMAIL_TO_FIELD_SEPARATOR} (puntkomma) — werkt in Outlook, Gmail en Apple Mail.
 */
export function formatContactEmailToField(c: EmailToFieldContact, overrideEmail?: string): string | null {
  const chosen = (overrideEmail ?? "").trim();
  const email = chosen.includes("@") ? chosen : preferredEmail(c);
  if (!email) return null;
  const name = displayName(c);
  if (/[,;<>"]/.test(name)) {
    return `"${name.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}" <${email}>`;
  }
  return `${name} <${email}>`;
}

/** Scheidingsteken tussen meerdere ontvangers in het Aan-veld (Outlook-voorkeur; ook bruikbaar in Gmail/Apple Mail). */
export const EMAIL_TO_FIELD_SEPARATOR = "; ";

export function formatContactsEmailToField(contacts: EmailToFieldEntry[]): {
  value: string;
  included: number;
  omitted: number;
} {
  const parts: string[] = [];
  let omitted = 0;
  for (const c of contacts) {
    const line = formatContactEmailToField(c, c.sendEmail);
    if (line) parts.push(line);
    else omitted += 1;
  }
  return {
    value: parts.join(EMAIL_TO_FIELD_SEPARATOR),
    included: parts.length,
    omitted,
  };
}
